import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoaderBtn from '@components/LoaderBtn/loaderBtn';
import NotFoundPages from '@components/NotFoundPages/notFoundPages';

import { searchTimeOut } from '@constants/general.const';

import OfficeNotFound from '@images/office-not-found.svg';

import OrganizationTabHeader from '@app/CreateOrganization/Organizations/organizationTabHeader';
import {
    getOfficeData,
    officeDeleteById,
} from '@app/CreateOrganization/step2/step2.const';
import StepBadgeComponent from '@app/CreateOrganization/StepBadgeComponent/StepBadgeComponent';

import OfficePopupStep2 from '../step2/officePopupStep2';

const OfficeTabList = ({ organizationId }: any) => {
    const dispatch = useDispatch<any>();

    const { officeStep2Data } = useSelector((state: any) => state);
    const { isDeleteOffice, isGetOfficeDataList } = officeStep2Data;

    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [dataList, setDataList] = useState<Array<any> | null>(null);
    const [search, setSearch] = useState<string | null>();

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if (search || search === '') {
            const getDataSearch: any = setTimeout(() => {
                getData();
            }, searchTimeOut);
            return () => clearTimeout(getDataSearch);
        }
    }, [search]);

    const getData = async () => {
        getOfficeData(
            dispatch,
            {
                nanoId: organizationId,
                searchText: search,
            },
            setDataList,
        );
    };

    const deleteById = async (officeId: string) => {
        officeDeleteById(officeId, dispatch, getData);
    };

    const handleClose = () => setShowPopup(false);
    const handleShow = () => setShowPopup(true);

    return (
        <div>
            <OrganizationTabHeader
                title={'Office List'}
                search={search}
                setSearch={setSearch}
                handleShow={handleShow}
                buttonText={'Add New Office'}
            />
            <div className="d-flex flex-wrap gap-2">
                {isDeleteOffice || isGetOfficeDataList ? (
                    <LoaderBtn />
                ) : (
                    dataList &&
                    dataList.length > 0 && (
                        <StepBadgeComponent
                            dataList={dataList}
                            deleteById={deleteById}
                            name={'office_name'}
                            nanoId={'office_nano_id'}
                            handleViewShow={false}
                            className="mnfw__badge_light lh-base text-dark py-2 fs-6 fw-semibold d-flex align-align-items-center bg-white border-opacity-25"
                        />
                    )
                )}
            </div>
            <NotFoundPages
                currentPageData={dataList}
                image={OfficeNotFound}
                message={`Lorem Ipsum`}
            />
            <OfficePopupStep2
                showPopup={showPopup}
                handleClose={handleClose}
                getDataListCall={getData}
                organizationId={organizationId}
            />
        </div>
    );
};

export default OfficeTabList;
